import React from 'react';
import './toggleMenu.scss';

interface ToggleMenuProps {
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}
export default function ToggleMenu({ className, onClick }: ToggleMenuProps) {
  return (
    <div className={`mobileToggleMenu ${className}`} onClick={onClick}>
      <span className="toggleMenuSpan"></span>
      <span className="toggleMenuSpan"></span>
      <span className="toggleMenuSpan"></span>
      <span className="toggleMenuSpanSmall"></span>
    </div>
  );
}
